import script from "./Informativo.vue?vue&type=script&setup=true&lang=js"
export * from "./Informativo.vue?vue&type=script&setup=true&lang=js"

import "./Informativo.vue?vue&type=style&index=0&id=543caf10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-543caf10"]])

export default __exports__